import { Injectable } from '@angular/core';
import { AlertController, ToastController, ToastOptions } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  i18n: Array<string> = []

  constructor(
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
  ) { }

  async toast(opts?: ToastOptions, handler: () => void = () => { }) {
    const _opts = {
      message: 'Registro salvo com sucesso',
      duration: 2000,
      color: 'success'
    }

    if (opts) {
      Object.keys(opts).forEach(key => {
        _opts[key] = opts[key];
      });
    }

    const toast = await this.toastCtrl.create(_opts);
    toast.present().then(() => { handler() })
  }

  async success(handler: () => void, opts?: any) {
    const header = (opts.hasOwnProperty('header')) ? opts.header : "";
    const message = (opts.hasOwnProperty('message')) ? opts.message : 'Registro gravado com sucesso';
    const modal = await this.alertCtrl.create({
      header,
      message,
      backdropDismiss: false,
      buttons: [
        {
          text: 'OK',
          handler: () => {
            if (handler) handler();
          }
        }
      ]
    });
    modal.present();
  }

  async error(opts?: any) {
    // const alertCtrl: AlertController = opts.alertCtrl;
    const header: string = opts.header || 'Atenção';
    const message: string = opts.message || 'Ocorreu um erro inesperado';
    const _buttons = [{ text: 'OK' }]
    if (!opts.buttons && opts.handler) _buttons[0]['handler'] = () => { opts.handler() };
    const buttons = opts.buttons || _buttons
    const modal = await this.alertCtrl.create({
      header,
      message,
      buttons
    });
    modal.present();
  }

  async alert(opts?: any, returnModel: boolean = false) {
    opts.header = opts.header || 'Atenção';
    opts.buttons = opts.buttons || [{ text: 'OK' }]
    const modal = await this.alertCtrl.create(opts);
    if (returnModel) return modal;
    modal.present();
  }

  async askBeforeRemove(handler: () => void) {
    // const alertCtrl: AlertController = opts.alertCtrl;
    const modal = await this.alertCtrl.create({
      header: 'Atenção',
      message: 'Deseja realmente excluir?',
      buttons: [
        {
          text: "Não",
          handler: () => { }
        },
        {
          text: "Sim",
          handler: () => {
            if (handler) handler();
          }
        }
      ]
    })
    modal.present();
  }

  async handleApiServiceError(err) {
    if (err?.messages) {
      this.alert({ message: err.messages.join('<br>') })
      return;
    }
    if (err?.message) {
      this.alert({ message: err.message })
      return;
    }

  }
}
